<template>
    <div class="loader" :style="{
        'border-top-color': color,
        width: size,
        height: size,
        'border-width': thickness,
        'animation-duration': speed
    }">
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        color: {
            type: String,
            default: '#FFFFFF',
        },

        thickness: {
            type: String,
            default: '.25rem',
        },

        size: {
            type: String,
            default: '1.5rem',
        },

        speed: {
            type: String,
            default: ' 0.5s',
        }
    },
    data: () => ({}),
    computed: {},
    methods: {},
    mounted () {}
}
</script>

<style lang="scss">
.loader {
    border: solid rgba(#FFFFFF, 0.2);
    border-top-style: solid;
    border-radius: 50%;
    animation: spin linear infinite;
}

@keyframes spin {
    0%   { transform: rotate(0deg);   }
    100% { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// Loader.vue?38f49f64